export default __webpack_public_path__ + "static/media/event_team_step.9d838fde.png";